import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome5-pro-icons',
	templateUrl:'./FontAwesome5ProIconsPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesome5ProIconsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesome5ProIconsPluginCompPage
{
	mdContent_917 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5pro.FontAwesome5ProIcons;
\`\`\``;
	mdContent_918 = `\`\`\`java
var icon = new FontAwesome<>(FontAwesome5ProStyles.Duotone, FontAwesome5ProIcons.alarm_clock)
    .primaryColour("#E53935")
    .secondaryColour("#FFCDD2")
    .setSize(FontAwesomeSizes.$2x);
\`\`\``;
	mdContent_919 = `\`\`\`java
var icon = new FontAwesome<>(FontAwesome5ProStyles.DuotoneSharp, FontAwesome5ProIcons.badge_check)
    .setSize(FontAwesomeSizes.Lg);
\`\`\``;
}
